import { render } from "./SubPage_Header.vue?vue&type=template&id=df55133c&scoped=true"
import script from "./SubPage_Header.vue?vue&type=script&lang=js"
export * from "./SubPage_Header.vue?vue&type=script&lang=js"

import "./SubPage_Header.vue?vue&type=style&index=0&id=df55133c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df55133c"]])

export default __exports__